import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { UserService } from '../services';
import { OrganizationService } from '../services/organization.service';

@Injectable({
  providedIn: 'root'
})
export class PermissionsGuard {
  constructor(
    private userService: UserService,
    private organizationService: OrganizationService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | boolean {
    const permissions: string[] = route.data.permissions;
    const noPermission = permissions.some(
      (permission: string) => !this.userService.hasPermission([permission])
    );

    if (noPermission) {
      this.router.navigate([
        this.organizationService.requireOrganization().slug
      ]);
      return false;
    }
    return true;
  }
}
